import * as ErrorMessages from './errorMessages';

export const required = (text: string) => {
  text = String(text);
  if (text && text.trim()) {
    return ErrorMessages.resetValidationMessage;
  } else {
    return ErrorMessages.isRequired;
  }
};

export const isValidAmount = (minValue?, maxValue?) => {
  return (text) => {
    let returnItem: any;
    if (minValue !== undefined && maxValue !== undefined) {
      let isAmountValid = false;
      if (!isNaN(text)) {
        const amount = parseInt(text, 10);

        if (amount >= minValue && amount <= maxValue) {
          isAmountValid = true;
        }
      }

      returnItem = isAmountValid
        ? ErrorMessages.resetValidationMessage
        : ErrorMessages.isValidAmount;
    } else {
      returnItem =
        text && !isNaN(text) && parseInt(text, 10) > 0
          ? ErrorMessages.resetValidationMessage
          : ErrorMessages.isValidAmount;
    }

    return returnItem;
  };
};

export const isValidTargetAmount = (minValue, maxValue, savingsCurrent) => {
  return (text, state) => {
    let isAmountValid = false;

    if (!isNaN(text)) {
      const targetAmount = parseInt(text, 10);

      if (
        targetAmount >= minValue &&
        targetAmount <= maxValue &&
        targetAmount > savingsCurrent
      ) {
        isAmountValid = true;
      }
    }

    return isAmountValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidAmount;
  };
};

export const isValidOriginalAmount = (minValue, maxValue, targetAmount) => {
  return (text, state) => {
    let isAmountValid = false;

    if (!isNaN(text)) {
      const savingsCurrent = parseInt(text, 10);

      if (
        savingsCurrent >= minValue &&
        savingsCurrent <= maxValue &&
        savingsCurrent < targetAmount
      ) {
        isAmountValid = true;
      }
    }

    return isAmountValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidAmount;
  };
};

export const isValidPercent = (minValue?, maxValue?) => {
  return (text) => {
    let isPercentValid = false;

    if (!isNaN(text)) {
      const percent = parseInt(text, 10);

      if (minValue !== undefined && maxValue !== undefined) {
        if (percent >= minValue && percent <= maxValue) {
          isPercentValid = true;
        }
      } else {
        if (percent > 0 && percent <= 100) {
          isPercentValid = true;
        }
      }
    }

    return isPercentValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidPercent;
  };
};

export const isValidFlatFee = (feeExistsInSystem: boolean, maxFARate?) => {
  return (text) => {
    let isFlatFeeValid = false;

    if (!isNaN(text)) {
      const flatFee = parseFloat(text);

      if (
        feeExistsInSystem &&
        flatFee <= maxFARate &&
        (flatFee > 0 || flatFee === 0)
      ) {
        isFlatFeeValid = true;
      }
    }

    return isFlatFeeValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidFlatFee;
  };
};

export const isValidPortfolioFee = () => {
  return (text) => {
    let isPortfolioFeeValid = false;

    if (!isNaN(text)) {
      const fee = parseFloat(text) * 100;

      if (fee >= 0 && fee <= 3) {
        isPortfolioFeeValid = true;
      }
    }

    return isPortfolioFeeValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidPortfolioFee;
  };
};

export const isValidYear = (minValue?, maxValue?) => {
  return (text) => {
    let isYearValid = false;

    if (!isNaN(text)) {
      const year = parseInt(text, 10);

      if (minValue !== undefined && maxValue !== undefined) {
        if (year >= minValue && year <= maxValue) {
          isYearValid = true;
        }
      } else {
        const currentYear = new Date().getFullYear();

        if (year > currentYear && year <= currentYear + 100) {
          isYearValid = true;
        }
      }
    }

    return isYearValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidYear;
  };
};

export const isValidAge = (minValue?, maxValue?) => {
  return (text) => {
    let isAgeValid = false;
    const filter = /^\d+$/;
    const isValidInteger = filter.test(text);

    if ((isValidInteger && Number(text)) || text === '0') {
      const age = parseInt(text, 10);

      if (minValue !== undefined && maxValue !== undefined) {
        if (age >= minValue && age <= maxValue) {
          isAgeValid = true;
        }
      } else {
        if (age > 0 && age <= 120) {
          isAgeValid = true;
        }
      }
    }

    return isAgeValid
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidAge;
  };
};

export const isValidEmail = (email) => {
  let returnItem: any;
  if (email && email.length > 256) {
    returnItem = ErrorMessages.maxAllowedLength(256);
  } else {
    // tslint:disable-next-line:max-line-length
    const filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    returnItem = filter.test(email)
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.isValidEmail;
  }
  return returnItem;
};

export const minLength = (length: number) => {
  return (text) => {
    return text.length >= length
      ? ErrorMessages.resetValidationMessage
      : ErrorMessages.minLength(length);
  };
};

export const requiredWithMinMaxLength = (minValue?, maxValue?) => {
  return (text) => {
    let returnItem: any;
    if (text && text.trim()) {
      if (minValue !== undefined && text.length < minValue) {
        returnItem = ErrorMessages.minLength(minValue);
      } else if (maxValue !== undefined && text.length > maxValue) {
        returnItem = ErrorMessages.maxAllowedLength(maxValue);
      } else {
        returnItem = ErrorMessages.resetValidationMessage;
      }
    } else {
      returnItem = ErrorMessages.isRequired;
    }
    return returnItem;
  };
};

export const clearValidation = () => {
  return (text) => {
    return ErrorMessages.resetValidationMessage;
  };
};

export const isValidInvestmentMonthlyContribution = (minValue?, maxValue?) => {
  return (text) => {
    let returnItem: any;
    if (minValue !== undefined && maxValue !== undefined) {
      let isAmountValid = false;
      if (!isNaN(text)) {
        const amount = parseInt(text, 10);

        if (amount >= minValue && amount <= maxValue) {
          isAmountValid = true;
        }
      }

      returnItem = isAmountValid
        ? ErrorMessages.resetValidationMessage
        : ErrorMessages.isValidInvestmentMonthlyContribution;
    } else {
      returnItem =
        text && !isNaN(text) && parseInt(text, 10) > 0
          ? ErrorMessages.resetValidationMessage
          : ErrorMessages.isValidInvestmentMonthlyContribution;
    }

    return returnItem;
  };
};
